import { render, staticRenderFns } from "./ZoneSettings.vue?vue&type=template&id=9486ef2a&"
import script from "./ZoneSettings.vue?vue&type=script&lang=js&"
export * from "./ZoneSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports